import { css } from '@linaria/core';

export const styledButton = css`
	--button-color-primary: var(--color-grey-95-solid);
	--button-color-secondary: var(--color-grey-6-solid);
	--button-color-additional: transparent;
	border-width: 2px;
	border-style: solid;
	--additional-padding-x: 0px;

	&.color-pink {
		--button-color-primary: var(--color-rose-58-solid);
		--button-color-secondary: var(--color-white-solid);
		--button-color-additional: transparent;
	}

	&:hover:not(.disabled, :focus, .selected) {
		--button-color-primary: var(--color-grey-85-solid);
		&.color-pink {
			--button-color-primary: var(--color-rose-48-solid);
		}
	}

	&:focus:not(:active, .selected, .loading) {
		--button-color-primary: var(--color-grey-6-solid);
		--button-color-additional: var(--color-white-solid);
		--button-color-secondary: var(--color-white-solid);

		&.color-pink {
			--button-color-primary: var(--color-grey-6-solid);
			--button-color-additional: var(--color-rose-58-solid);
			--button-color-secondary: var(--color-rose-58-solid);
		}
	}

	&:active:not(.selected) {
		--button-color-primary: var(--color-grey-68-solid);
	}

	&.disabled:not(.selected) {
		--button-color-primary: var(--color-grey-44-solid);
		--button-color-secondary: var(--color-grey-85-solid);
	}

	&.selected {
		/* TODO complete me after design will be ready */
	}
`;
